import { useState, useCallback, useEffect } from 'react';
import tripsService from '../../../services/trips/trips.service';

export interface IEditTripNameImageModel {
  title: string;
  imageUrl: string;
}

export const useEditTripNameImage = (
  tripId: string | null,
  initialTitle: string,
  initialImageUrl: string,
  onSuccess?: () => void
) => {
  const [tripData, setTripData] = useState<IEditTripNameImageModel>({
    title: initialTitle || '',
    imageUrl: initialImageUrl || ''
  });

  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Update state when initial values change (modal opens with new trip)
  useEffect(() => {
    setTripData({
      title: initialTitle || '',
      imageUrl: initialImageUrl || ''
    });
  }, [initialTitle, initialImageUrl]);

  // Validate form
  useEffect(() => {
    const isValid = tripData.title.trim().length > 0;
    setValidated(isValid);
  }, [tripData]);

  const handleInputChange = (
    field: keyof IEditTripNameImageModel,
    value: any
  ) => {
    setTripData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!tripId || !validated) return;

    setIsSubmitting(true);
    try {
      const success = await tripsService.updateTripNameAndImage(
        tripId,
        tripData.title,
        tripData.imageUrl
      );

      if (success) {
        onSuccess?.();
      } else {
        alert('Failed to update trip');
      }
    } catch (error: any) {
      console.error('Error updating trip:', error);
      alert(error?.message || 'An error occurred while updating the trip');
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    tripData,
    validated,
    isSubmitting,
    handleInputChange,
    handleSubmit
  };
};
